import React from "react";  
import ReactDOM from "react-dom/client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});


//const container = document.getElementById('root');
/*

hydrateRoot(document.getElementById('root'), <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>);
*/


const root = ReactDOM.createRoot(document.getElementById("root"));



  

  root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
  ,
);





/*
if (container.hasChildNodes()) {
   
   const root = hydrateRoot(container, <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>);

  
}else{
  const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </React.StrictMode>
    );  

}
    
// 2. Create a React root
//const root = createRoot(container);

// 3. Render your application
//root.render(<App />);

//const root = ReactDOM.createRoot(document.getElementById("root"));



  
/*
  root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
  ,
);
*/

  

/*
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
  ,
);

*/

